import { queryOptions } from "@tanstack/react-query";
import { listSponsors } from "./sponsors.functions";

export type Sponsor = {
  id: string;
  name: string;
  tier: "Platinum" | "Gold" | "Silver" | "Partner";
  logo_url: string | null;
  website_url: string | null;
  blurb: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export const sponsorsQueryOptions = () =>
  queryOptions({
    queryKey: ["sponsors"],
    queryFn: async () => {
      const data = await listSponsors();
      return data as Sponsor[];
    },
  });
